import React from 'react'
import { useAuth } from '../../../contexts/AuthContext'
import { format } from 'date-fns'
import { es, enUS } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'

export const Header = () => {

    const { user } = useAuth();
    const { t, i18n } = useTranslation();
    const date = format(
        new Date(),
        "EEEE d MMMM, yyyy",
        { locale: i18n.language === 'es' ? es : enUS }
    );


    return (
        <header className="flex flex-row justify-between items-center border-b border-grey-light px-6 py-6 mb-4 bg-white">
            <p className="text-2xl font-medium">{t('hello')}, {user?.doctor?.first_name || user?.nickname}</p>
            <p className="capitalize text-xs text-grey-text">{date}</p>
        </header>
    )
}